/**
 * Shared customer-specific id sets used for billto / customer-driven
 * branching across the app. Each constant gets a one-line comment about
 * which behavior it gates so future readers (and future swaps) are obvious.
 *
 * Keep this file small and source-of-truth. Logic that consumes these
 * (e.g. "show THD Reason dropdown when billto ∈ THD_BILLTOS") lives in
 * the consuming component, not here.
 */

/**
 * Bill-to numbers marking an order as THD (The Home Depot family). Gates
 * THD-specific UI like the THD Reason dropdown and the THD-only trouble-ticket
 * categories. Each one routes to its own EDI partner handle on the backend
 * (831/897 -> thdlognetedi, 827 -> hdslognetedi, 9025 -> cbtlognetedi); that
 * mapping is backend-only, so only the membership list is mirrored here.
 * Mirror this list in backend app/core/constants.py THD_BILLTO_EDIHANDLES
 * — both ends should change together.
 */
export const THD_BILLTOS: ReadonlyArray<number> = [831, 897, 827, 9025];

/**
 * Convenience predicate. Returns true when the given billto (number or
 * string) belongs to the THD set.
 */
export function isThdBillto(billto: number | string | null | undefined): boolean {
  if (billto === null || billto === undefined) return false;
  const n = typeof billto === 'number' ? billto : parseInt(String(billto), 10);
  if (Number.isNaN(n)) return false;
  return THD_BILLTOS.includes(n);
}